import { useState } from "react";
import { useData, useDispatch } from "./DataContext.js";
import { getSimParam, getAndShowDiffs } from "./utils.js";

import Card from "react-bootstrap/Card";
import Button from "react-bootstrap/Button";
import Collapse from "react-bootstrap/Collapse"
import ButtonGroup from "react-bootstrap/ButtonGroup";

import Markdown from "react-markdown";

import CardTitle from "./CardTitle.js";
import ButtonGrid from "./ButtonGrid.js";
import MyButton from "./MyButton.js";
import AmendmentList from "./AmendmentList.js";


export default function ArticleCard (props)
{
    const gData = useData();

    const articleID = props.articleID;

    let article = null;
    let articleType = "article";

    if (articleID !== null)
    {
	article = gData.article[articleID];
	articleType = article.type;
    }

    const [read, setRead] = useState(articleType === "article");
    function handleRead () { setRead(!read); }
    
    // RENDER
    return (
	<Card className="shadow-sm w-100">
	    <ArticleCard.Header article={article} read={read} handleRead={handleRead}/>
	    <Collapse in={read}>
		<div>
		    <ArticleCard.Body article={article}/>
		    <ArticleCard.Footer article={article}/>
		</div>
	    </Collapse>
	</Card>
    );
}

ArticleCard.Header = function Header (props)
{
    const gData = useData();

    const article = props.article;

    let articleType = "";
    let articleTitle = "";
    let articleSubtitle = "";

    if (article === null)
    {
	articleType = "article";
	articleTitle = "";
	articleSubtitle = "Propositions de nouveaux articles";
    }

    else {
	const firstArticleID = article.firstArticleID;

	// ARTICLE NUM    
	// TODO : optimize with more global computation of that list ?
	let currentNum = 1;
	const articleNums = Object
	    .entries(gData.article)
	    .filter(([id, article]) => {
		return article.simID === gData.simID
		    && article.sessionNum === 0
		    && article.selected === 1
		    && article.type === "article"
		    && article.rank >= 0;
	    })
    	    .sort(([id1, article1], [id2, article2]) => article1.rank - article2.rank)
	    .map(([id, article]) => { return { articleID: article.articleID, num: currentNum++ }; })
	    .filter((articleNum) => articleNum.articleID === firstArticleID);

	const articleNum = articleNums.length === 0 ? null : articleNums[0].num;

	articleType = article.type;
	articleTitle = articleType === "article" ? article.title : "";
	articleSubtitle = articleType !== "article" ? article.title : "Article" + (articleNum !== null ? " " + articleNum : "");
    }
    
    return (
	<Card.Header>
	    <CardTitle title={articleTitle} subtitle={articleSubtitle}>
		{articleType !== "article" && (<MyButton icon={props.read ? "readLess" : "readMore"} variant="outline-secondary" onClick={props.handleRead}/>)}
	    </CardTitle>
	</Card.Header>
    );
}

ArticleCard.Body = function Body (props)
{
    const article = props.article;
    if (article === null) return (<></>);
    
    const articleType = article.type;
    const articleContent = article.content;

    let content = articleContent;
    const isDiffContent = props.amendment !== null && props.prevArticle !== null;

    if (isDiffContent)
    {
	const amendmentContent = props.amendment.content;
	const prevArticleContent = props.prevArticle.content;
	
	if (props.present) content = getAndShowDiffs(prevArticleContent, amendmentContent, articleContent);
	else content = getAndShowDiffs(prevArticleContent, amendmentContent);
    }
    
    // TODO: use complex diff for sequential amendment?
    /* let showDiffContent = (<></>);
     * if (presentAmendmentState !== null && amendmentState === "submitted")
     * {
       const diffContent = computeDiffs(prevArticle.content, article.content, amendmentContent);
       showDiffContent = getAndShowDiffs(article.content, diffContent);
     * }
     * else showDiffContent = getAndShowDiffs(prevArticle.content, amendmentContent); */

    let paragraphList = (<span className="fst-italic">Article supprimé.</span>);
    if (isDiffContent || content.some((paragraph) => paragraph.trim() !== ""))
    {
	paragraphList = content
	    .map((paragraph, index) => {
		let num = (<></>);
		if (content.length > 1) num = (<span className="fw-medium pe-2">{String.fromCharCode('a'.charCodeAt(0) + index)}.</span>);
		if (! isDiffContent && paragraph.trim() === "") paragraph = (<span className="fst-italic">Alinéa supprimé.</span>);
		if (articleType === "article") return (<div key={index}>{num}{paragraph}</div>);
		else return (<div key={index}>{num}<Markdown>{paragraph}</Markdown></div>);
	    });
    }

    return (
	<Card.Body>
	    <div className="d-flex flex-column gap-2">{paragraphList}</div>
	</Card.Body>
    );
}

ArticleCard.Body.defaultProps = {
    amendment: null,
    article: null,
    prevArticle: null,
    present: false
};



ArticleCard.Footer = function Footer (props)
{
    const gData = useData();
    const gDispatch = useDispatch();

    const article = props.article;

    let articleID;
    let articleType;
    let articleSessionNum;
    let firstArticleID;
    let prevArticleID;
    let selected;

    if (article !== undefined && article !== null)
    {
	articleID = article.articleID;
	articleType = article.type;
	articleSessionNum = article.sessionNum;
	firstArticleID = article.firstArticleID;
	prevArticleID = article.prevArticleID;
	selected = gData.article[firstArticleID].selected === 1;
    }

    else {
	articleID = null;
	articleType = "article";
	articleSessionNum = 0;
	firstArticleID = null;
	prevArticleID = null;
	selected = true;
    }

    const groupType = gData.groupID !== null && gData.group[gData.groupID] !== undefined ? gData.group[gData.groupID].type : null;
    const sessionStep = getSimParam(gData, "sessionStep");
    const personalArticles = getSimParam(gData, "personalArticles");


    // ACTIONS

    function handleNewAmendment () { gDispatch({ type: "showEditAmendment", articleID, prevArticleID, sessionNum: articleSessionNum }); }
    function handleNewArticle () { gDispatch({ type: "showEditAmendment", articleID: null, prevArticleID: null, sessionNum: gData.sim[gData.simID].sessionNum }); }

    function selectArticle () { gDispatch({ type: "upload", table: "article", id: firstArticleID, data: { selected: 1 } }); }
    function unselectArticle () { gDispatch({ type: "upload", table: "article", id: firstArticleID, data: { selected: 0 } }); }

    
    // BUTTONS

    const leftButtonList = [];
    const rightButtonList = [];

    if (gData.groupID === null && personalArticles && firstArticleID !== null)
    {
	if (selected) leftButtonList.push(<Button variant="outline-secondary" size="md" onClick={unselectArticle}>Mettre en réserve</Button>);
	else leftButtonList.push(<Button variant="outline-secondary" size="md" onClick={selectArticle}>Ajouter à la liste</Button>);
    }
    
    if (gData.groupID !== null && groupType === "delegation" && articleType === "article" && sessionStep === "write")
    {
	if (articleID !== null) rightButtonList.push(<Button key={"newAmendment"} variant="primary" size="md" onClick={handleNewAmendment}>Rédiger un nouvel amendement</Button>);
	else rightButtonList.push(<Button key={"newArticle"} variant="primary" size="md" onClick={handleNewArticle}>Rédiger un nouvel article</Button>);
    }

    let buttonGroup = null;
    if (articleType === "article") buttonGroup = (<ButtonGroup className="text-center w-100"><AmendmentList.Buttons articleID={articleID}/></ButtonGroup>);


    // RENDER
    
    if (leftButtonList.length === 0 && rightButtonList.length === 0 && buttonGroup === null) return (<></>);
    else {
	return (
	    <>
		<Card.Footer className="d-flex flex-column gap-2">
		    {(leftButtonList.length > 0 || rightButtonList.length > 0) && (
			<ButtonGrid>
			    <ButtonGrid.Left>{leftButtonList}</ButtonGrid.Left>
			    <ButtonGrid.Right>{rightButtonList}</ButtonGrid.Right>
			</ButtonGrid>
		    )}
		    {buttonGroup}
		</Card.Footer>
	    </>
	);
    }
}

ArticleCard.defaultProps = {
    articleID: null
};
